// @flow
import { EstimatesActionTypes } from './constants';

type EstimatesAction = { type: string, payload: {} | string };

// common success
export const estimatesApiResponseSuccess = (actionType: string, data: any): EstimatesAction => ({
    type: EstimatesActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const estimatesApiResponseError = (actionType: string, error: string): EstimatesAction => ({
    type: EstimatesActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const createEstimate = (estimate:any): EstimatesAction => ({
    type: EstimatesActionTypes.CREATE_ESTIMATE,
    payload: estimate,
});

export const listEstimatesByClient = (contactoId:any): EstimatesAction => ({
    type: EstimatesActionTypes.LIST_ESTIMATES_BY_CLIENT,
    payload: {contactoId},
});

export const resetEstimates = (): EstimatesAction => ({
    type: EstimatesActionTypes.RESET,
    payload: {},
});

